import React from 'react';
import ServicePage from '../../components/ServicePage';
import { Code, Bot, Brain, Link, Layers, Key, FileCode2, ClipboardList, CheckCircle, BarChart } from 'lucide-react';

export default function CodeAudit() {
  return (
    <ServicePage
      title="代码审计服务"
      subtitle="SAST 自动化 + 人工深度双引擎 · 漏洞挖掘量是纯工具 2.5 倍"
      description="卓迈代码审计采用「SAST 自动化扫描 + 人工深度分析」双引擎模式。自动化部分快速覆盖已知漏洞模式，人工部分专注业务逻辑漏洞、高危调用链分析、框架安全配置审计——这些是任何工具都发现不了的。两者结合，单项目漏洞发现量平均是纯工具扫描的 2.5 倍，支持 Java、Go、Python、PHP、Node.js 等主流语言。"
      icon={<Code size={40} strokeWidth={1.5} />}
      color="#db2777"
      benefits={[
        'SAST + 人工双引擎，漏洞发现量是纯工具 2.5 倍',
        '覆盖 OWASP Top 10 + CWE/SANS Top 25',
        '专注业务逻辑漏洞，工具发现不了的我们来找',
        '支持 Java/Go/Python/PHP/Node.js 主流语言',
        '漏洞含 PoC 验证 + 修复代码示例',
      ]}
      features={[
        {
          icon: <Bot size={24} />,
          title: 'SAST 自动化扫描',
          desc: '基于多款主流 SAST 引擎（SonarQube + Semgrep + Checkmarx）并行扫描，规则库持续更新，覆盖 CWE 500+ 种漏洞类型，输出原始扫描结果供人工研判基础。',
          points: ['多引擎并行提升覆盖率', 'CWE 500+ 漏洞类型', '数据流/污点分析', '规则库持续更新维护'],
        },
        {
          icon: <Brain size={24} />,
          title: '人工深度分析',
          desc: '有经验的安全工程师逐行审读高危代码路径，重点关注自动化工具盲区：业务逻辑漏洞、越权逻辑、水平越权、支付绕过、接口鉴权缺失等——这些漏洞在真实攻击中比 SQL 注入更常被利用。',
          points: ['业务逻辑漏洞挖掘', '越权与鉴权缺失', '支付与金融逻辑', '敏感数据暴露分析'],
        },
        {
          icon: <Link size={24} />,
          title: '危险调用链追踪',
          desc: '从用户输入到危险函数调用的完整数据流追踪——eval、exec、反序列化、文件写入等高危函数的调用链分析，评估实际可利用性，过滤无法真实触发的理论漏洞。',
          points: ['危险函数调用追踪', '反序列化链分析', '命令执行可达性评估', 'XXE/SSRF 调用链'],
        },
        {
          icon: <Layers size={24} />,
          title: '框架与配置审计',
          desc: 'Spring Security、Shiro、JWT、OAuth2 等框架的安全配置审计，识别鉴权绕过、Token 伪造、CORS 配置不当等框架层漏洞，这类问题往往是严重漏洞的根源。',
          points: ['Spring Security 配置审计', 'JWT 签名验证审查', 'Shiro 反序列化评估', 'CORS 配置安全检查'],
        },
        {
          icon: <Key size={24} />,
          title: '硬编码敏感信息',
          desc: '扫描代码库中硬编码的 API Key、数据库密码、私钥证书、内部 IP、云凭证等敏感信息，支持 Git 历史记录扫描，防止开发人员提交了敏感信息又以为删除了就安全了。',
          points: ['API Key / 密码硬编码', 'Git 历史记录扫描', '云服务凭证检测', '私钥证书泄露识别'],
        },
        {
          icon: <FileCode2 size={24} />,
          title: 'PoC 验证 + 修复代码',
          desc: '每个高危漏洞提供可复现的 PoC 代码（仅交付给客户，不公开），以及对应的修复代码示例——不只告诉你「哪里有问题」，而是直接给你「改成什么样就安全了」。',
          points: ['高危漏洞 PoC 验证', '修复代码示例附带', '框架安全配置推荐', '修复后免费复测验证'],
        },
      ]}
      process={[
        { icon: <ClipboardList size={24} />, title: '范围确认', desc: '确认代码仓库、技术栈、重点审计模块，签署保密协议（NDA）' },
        { icon: <Bot size={24} />, title: 'SAST 扫描', desc: '多引擎自动化扫描，快速获取原始漏洞列表和代码调用关系图' },
        { icon: <Brain size={24} />, title: '人工研判', desc: '专家逐一研判高危发现，人工挖掘逻辑漏洞和调用链，验证可利用性' },
        { icon: <CheckCircle size={24} />, title: 'PoC 验证', desc: '对高危漏洞编写 PoC，验证真实危害，过滤理论上不可利用的误报' },
        { icon: <BarChart size={24} />, title: '报告交付', desc: '提交详细审计报告 + 修复代码示例，修复完成后免费复测验证' },
      ]}
      nextService={{ name: '资产测绘服务', path: '/services/asset-mapping' }}
    />
  );
}
